import { select, race, take, delay, call, put } from "redux-saga/effects";
import { createSelector } from "reselect";
import { ctaLabelSelectorProps } from "@grandvisionhq/configurator";
import { actions, statusLoading, statusUninit, statusSuccess } from "@grandvisionhq/state";
import { LensTypeStepContainer } from "../../../../../../../../steps/LensTypeStep/steps/LensTypeStep/LensTypeStepContainer.js";
import { startPrescriptionGlassesConfiguration } from "../../../../../../../state/actions.js";
import { loadMissingPackages } from "../../../../../../../bundles/state/bundles/sagas.js";
import "../../../../../../../add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../../bundles/state/bundles/selectors.js";
import "../../../../../../../bundles/state/bundles/reducer.js";
import { getSelectedLensType, getFrameSku, getLensTypes } from "../../../../../../state/configurator/selectors.js";
import "../../../../../../state/configurator/reducer.js";
import "../../../../../../../products/state/products/selectors.js";
import "../../../../../../../products/state/products/reducer.js";
import { fetchLensTypesSuccess, fetchLensTypesFailed } from "../../../../../../../bundles/state/bundles/actions.js";
import { selectLensType } from "../../../../../../../configurations/state/configurations/actions.js";
const lensTypeStepBase = {
  *onEnter() {
    yield race([take(startPrescriptionGlassesConfiguration), delay(3e3)]);
    yield call(selectDefaultLensType);
  },
  *onNext() {
    const lensType = yield select(
      getSelectedLensType
    );
    if (!lensType) {
      return new Error(`Selecting a lens-type is required`);
    }
  },
  ctaLabel: createSelector(
    ctaLabelSelectorProps,
    getSelectedLensType,
    ({ defaultCtaLabel, alternativeCtaLabel }, selectedLensType) => {
      return Number(selectedLensType?.variants?.length) > 1 && alternativeCtaLabel ? { key: alternativeCtaLabel } : { key: defaultCtaLabel };
    }
  ),
  view: LensTypeStepContainer
};
const isSuccess = actions.guard(fetchLensTypesSuccess);
const isFailed = actions.guard(fetchLensTypesFailed);
function* selectDefaultLensType() {
  const lensType = yield select(
    getSelectedLensType
  );
  const frameSku = yield select(getFrameSku);
  if (!frameSku) {
    console.warn(`Did not find a frame SKU for this configuration. Received: ${frameSku}`);
    return;
  }
  if (!lensType) {
    let lensTypes = yield select(getLensTypes);
    if (statusLoading(lensTypes) || statusUninit(lensTypes)) {
      const [success] = yield race([
        take((a) => isSuccess(a)),
        take((a) => isFailed(a) && a.payload.frameSku === frameSku),
        delay(3e4, true)
      ]);
      if (success) {
        lensTypes = yield select(getLensTypes);
      }
    }
    if (statusSuccess(lensTypes)) {
      let lensTypeSku = lensTypes.result[0]?.sku;
      for (const product of lensTypes.result) {
        if (product.isDefault) {
          lensTypeSku = product.sku;
          break;
        }
      }
      if (lensTypeSku) {
        yield put(
          selectLensType({
            frameSku,
            lensTypeSku,
            reason: "default selection"
          })
        );
      }
    }
  } else {
    yield call(loadMissingPackages, lensType.sku);
  }
}
export {
  lensTypeStepBase,
  selectDefaultLensType
};
//# sourceMappingURL=lens-type.js.map
